module.exports = __webpack_public_path__ + "img/s-accordion.1ff37446.webp";